import React, { Component } from 'react';
import { AuthConsumer } from '../../../auth/AuthContext';
import withStyles from '@material-ui/core/styles/withStyles';
import Cancel from '@material-ui/icons/CancelOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
// @material-ui/icons
import Close from '@material-ui/icons/Close';
// core components
import Button from 'components/CustomButtons/Button.jsx';

import modalSstyles from 'assets/jss/material-dashboard-pro-react/modalStyle.jsx';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// @material-ui/icons
import Check from '@material-ui/icons/Check';
import Checkbox from '@material-ui/core/Checkbox';

import checkboxStyles from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx';
import tenantRoles from '../../../auth/tenantRoles';

const styles = { ...modalSstyles, ...checkboxStyles };

class FlushPricesButton extends Component {
  state = {
    showModal: false,
    sendConfirmationMail: false,
  };
  showModal = () => {
    this.setState({
      showModal: true,
    });
  };
  hideModal = () => {
    this.setState({ showModal: false });
  };

  onConfirm = () => {
    const { onSyncPrices } = this.props;
    onSyncPrices();
    this.hideModal();
  };
  render() {
    const { classes } = this.props;
    const { showModal } = this.state;
    return (
      <AuthConsumer>
        {({ isAuthorized }) =>
          isAuthorized([tenantRoles.SKIDATA_SYNC_PRICES]) ? (
            <React.Fragment>
              <Button color={'info'} onClick={this.showModal}>
                <span style={{ marginRight: 10 }}>Preise synchronisieren</span>
              </Button>
              <Dialog
                classes={{
                  root: classes.center,
                  paper: classes.modal,
                }}
                open={showModal}
                keepMounted
                onClose={this.hideModal}
              >
                <DialogTitle
                  id="classic-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    justIcon
                    className={classes.modalCloseButton}
                    key="close"
                    color="transparent"
                    onClick={this.hideModal}
                  >
                    <Close className={classes.modalClose} />
                  </Button>
                </DialogTitle>
                <DialogContent
                  id="modal-slide-description"
                  className={classes.modalBody}
                  style={{ marginBottom: 20 }}
                >
                  <h5>
                    Wollen sie wirklich die Preise neu mit Skidata abgleichen?
                  </h5>
                  <h6>
                    Die neuen Preise sollten in den n&auml;chsten Minuten
                    angezeigt werden. Der Preis Cache wird inkrementell wieder
                    aufgebaut.
                  </h6>
                </DialogContent>
                <DialogActions
                  className={
                    classes.modalFooter + ' ' + classes.modalFooterCenter
                  }
                >
                  <Button onClick={this.hideModal}>Abbrechen</Button>
                  <Button onClick={this.onConfirm} color="danger">
                    Preise synchronisieren
                  </Button>
                </DialogActions>
              </Dialog>
            </React.Fragment>
          ) : null
        }
      </AuthConsumer>
    );
  }
}

export default withStyles(styles)(FlushPricesButton);



// WEBPACK FOOTER //
// ./src/views/skidata/components/FlushPricesButton.jsx